(function () {
  if (window.__BRIDGECUSTOM_CART_JS__) return;
  window.__BRIDGECUSTOM_CART_JS__ = true;

  var STYLE_ID = "bridgecustom-cart-css";
  if (!document.getElementById(STYLE_ID)) {
    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent =
      ".bridgecustom-edit-design{display:inline-flex;align-items:center;justify-self:start;align-self:start;width:fit-content;max-width:max-content;gap:.4rem;margin:.55rem 0 .9rem;padding:0;border:0;background:none;color:#334155;font-size:.8125rem;font-weight:600;cursor:pointer;text-decoration:underline;text-underline-offset:2px}" +
      ".cart-items__media-container[data-bc-zoom]{cursor:zoom-in}" +
      "dialog.bridgecustom-edit-modal{position:fixed;inset:0;width:100%;max-width:none;height:100%;max-height:none;margin:0;padding:0;border:0;background:rgba(15,23,42,.55);z-index:2147483646;display:flex;align-items:center;justify-content:center}" +
      "dialog.bridgecustom-edit-modal::backdrop{background:rgba(15,23,42,.55)}" +
      ".bridgecustom-edit-modal__dialog{position:relative;width:min(1120px,100%);height:min(760px,100%);background:#fff;border-radius:16px;box-shadow:0 24px 80px rgba(15,23,42,.35);overflow:hidden;display:flex;flex-direction:column}" +
      "@media (max-width:749px){dialog.bridgecustom-edit-modal{padding:0;background:#fff}.bridgecustom-edit-modal__dialog{width:100%;height:100%;max-height:none;border-radius:0}}" +
      ".bridgecustom-edit-modal__bar{display:flex;align-items:center;justify-content:center;position:relative;padding:14px 48px;border-bottom:1px solid #e2e8f0;font-weight:700;font-size:15px;color:#0f172a}" +
      ".bridgecustom-edit-modal__close{position:absolute;right:12px;top:50%;transform:translateY(-50%);width:36px;height:36px;border:0;background:none;font-size:22px;line-height:1;cursor:pointer;color:#64748b}" +
      ".bridgecustom-edit-modal__frame{flex:1;width:100%;min-height:0;border:0;background:#fff}" +
      "dialog.bridgecustom-edit-modal.is-preload{left:-200vw;visibility:hidden;pointer-events:none}" +
      ".bridgecustom-edit-modal__body{position:relative;flex:1;min-height:0;display:flex}" +
      ".bridgecustom-edit-modal__loading{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;background:#fff;color:#64748b;font-size:13px;transition:opacity .15s}" +
      ".bridgecustom-edit-modal__loading i{width:30px;height:30px;border-radius:50%;border:3px solid #e2e8f0;border-top-color:#0f172a;animation:bc-edit-spin .8s linear infinite}" +
      ".bridgecustom-edit-modal.is-ready .bridgecustom-edit-modal__loading{opacity:0;pointer-events:none}" +
      "@keyframes bc-edit-spin{to{transform:rotate(360deg)}}" +
      ".bridgecustom-edit-modal__status{position:absolute;inset:auto 0 0 0;padding:10px 16px;background:#0f172a;color:#fff;font-size:13px;font-weight:600;text-align:center}" +
      ".bridgecustom-zoom{position:fixed;inset:0;z-index:2147483001;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(15,23,42,.82)}" +
      ".bridgecustom-zoom__card{position:relative;max-width:min(960px,calc(100vw - 32px));max-height:92vh}" +
      ".bridgecustom-zoom__card img{display:block;width:min(720px,calc(100vw - 32px));height:auto;max-width:100%;max-height:92vh;object-fit:contain;border-radius:12px;background:#fff;box-shadow:0 24px 80px rgba(15,23,42,.45)}" +
      ".bridgecustom-zoom__close{position:absolute;top:8px;right:8px;z-index:2;width:36px;height:36px;display:flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:999px;background:#fff;color:#0f172a;font-size:22px;line-height:1;cursor:pointer;box-shadow:0 4px 16px rgba(15,23,42,.18)}";
    document.head.appendChild(style);
  }

  function appOriginFrom(button) {
    return (
      (button && button.getAttribute("data-app-origin")) ||
      window.__BRIDGECUSTOM_APP_ORIGIN__ ||
      "https://app.bridgecustom.com"
    ).replace(/\/$/, "");
  }

  function applyCartPreviewImages() {
    fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        cart.items.forEach(function (item) {
          var props = item.properties || {};
          var preview = props._bc_preview || "";
          // A customer photo is not a preview: keep the product mockup the theme rendered.
          var isCustomerPhoto = Object.keys(props).some(function (key) {
            return key.indexOf("_bc_photo_") === 0 && props[key] === preview;
          });
          if (!preview || isCustomerPhoto) return;
          document.querySelectorAll('[data-key="' + item.key + '"] .cart-items__media-image').forEach(function (img) {
            if (img.getAttribute("src") !== preview) img.setAttribute("src", preview);
          });
        });
      })
      .catch(function () {});
  }

  document.addEventListener("DOMContentLoaded", applyCartPreviewImages);
  document.addEventListener("shopify:section:load", applyCartPreviewImages);
  window.setTimeout(applyCartPreviewImages, 400);
  window.setTimeout(applyCartPreviewImages, 1600);
  document.addEventListener("cart:updated", applyCartPreviewImages);
  document.addEventListener("cart:change", applyCartPreviewImages);

  var activeModal = null;

  function closeModal() {
    if (!activeModal) return;
    if (typeof activeModal.close === "function") {
      try {
        activeModal.close();
      } catch (err) {}
    }
    activeModal.remove();
    activeModal = null;
    document.body.style.removeProperty("overflow");
  }

  var zoomOverlay = null;
  function closeImageZoom() {
    if (!zoomOverlay) return;
    zoomOverlay.remove();
    zoomOverlay = null;
    document.body.style.removeProperty("overflow");
  }
  function openImageZoom(src, alt) {
    if (!src) return;
    closeImageZoom();
    var overlay = document.createElement("div");
    overlay.className = "bridgecustom-zoom";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.innerHTML =
      '<div class="bridgecustom-zoom__card"><button type="button" class="bridgecustom-zoom__close" aria-label="Close"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true" style="display:block"><path d="M6 6l12 12M18 6 6 18"/></svg></button><img src="' +
      String(src).replace(/"/g, "&quot;") +
      '" alt="' +
      String(alt || "").replace(/"/g, "&quot;") +
      '"></div>';
    overlay.addEventListener("click", function (event) {
      if (event.target === overlay || (event.target.closest && event.target.closest(".bridgecustom-zoom__close"))) {
        closeImageZoom();
      }
    });
    document.body.style.overflow = "hidden";
    document.body.appendChild(overlay);
    zoomOverlay = overlay;
  }
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeImageZoom();
  });

  async function replaceCartLine(opts) {
    var change = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: opts.lineKey, quantity: 0 }),
    });
    if (!change.ok) throw new Error("Could not update cart line");
    var payload = {
      items: [
        {
          id: Number(opts.variantId),
          quantity: Number(opts.quantity) || 1,
          properties: opts.properties || {},
        },
      ],
    };
    if (opts.sellingPlan) payload.items[0].selling_plan = Number(opts.sellingPlan);
    var add = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    });
    if (!add.ok) throw new Error("Could not add updated design");
    window.location.reload();
  }

  function editSrc(button) {
    var origin = appOriginFrom(button);
    var shop = button.getAttribute("data-shop") || "";
    var productId = button.getAttribute("data-product-id") || "";
    var designId = button.getAttribute("data-design-id") || "";
    var color = button.getAttribute("data-product-color") || "";
    var previewImage = button.getAttribute("data-preview-image") || "";
    if (previewImage.indexOf("//") === 0) previewImage = "https:" + previewImage;
    return (
      origin +
      "/customize?shop=" +
      encodeURIComponent(shop) +
      "&product=" +
      encodeURIComponent(productId) +
      "&embed=1&slot=modal" +
      (designId ? "&design=" + encodeURIComponent(designId) : "") +
      (color ? "&color=" + encodeURIComponent(color) : "") +
      (/^https:\/\//i.test(previewImage) ? "&image=" + encodeURIComponent(previewImage) : "")
    );
  }

  // Modals built ahead of time (hidden off-screen) so the iframe is already loaded on click.
  // An iframe reloads if moved in the DOM, so the whole dialog is prebuilt and later shown in place.
  var preloaded = {};
  var MAX_PRELOADS = 4;

  function buildModal(src) {
    var overlay = document.createElement("dialog");
    overlay.className = "bridgecustom-edit-modal is-preload";
    overlay.setAttribute("aria-label", "Edit Personalization");
    overlay.innerHTML =
      '<div class="bridgecustom-edit-modal__dialog">' +
      '<div class="bridgecustom-edit-modal__bar">Edit Personalization<button type="button" class="bridgecustom-edit-modal__close" aria-label="Close">&times;</button></div>' +
      '<div class="bridgecustom-edit-modal__body">' +
      '<iframe class="bridgecustom-edit-modal__frame" title="Edit Personalization" src="' +
      src.replace(/"/g, "&quot;") +
      '"></iframe>' +
      '<div class="bridgecustom-edit-modal__loading" aria-hidden="true"><i></i>Loading your design…</div>' +
      "</div></div>";
    overlay.querySelector("iframe").addEventListener("load", function () {
      overlay.classList.add("is-ready");
    });
    document.body.appendChild(overlay);
    return overlay;
  }

  function preloadModal(button) {
    if (!button) return;
    var src = editSrc(button);
    if (preloaded[src] || Object.keys(preloaded).length >= MAX_PRELOADS) return;
    preloaded[src] = buildModal(src);
  }

  function openModal(button) {
    closeModal();
    var origin = appOriginFrom(button);
    var lineKey = button.getAttribute("data-line-key") || "";
    var variantId = button.getAttribute("data-variant-id") || "";
    var quantity = button.getAttribute("data-quantity") || "1";
    var sellingPlan = button.getAttribute("data-selling-plan") || "";
    var src = editSrc(button);

    var overlay = preloaded[src] || buildModal(src);
    delete preloaded[src];
    overlay.classList.remove("is-preload");
    document.body.style.overflow = "hidden";
    if (typeof overlay.showModal === "function") overlay.showModal();
    else overlay.setAttribute("open", "");
    activeModal = overlay;

    overlay.querySelector(".bridgecustom-edit-modal__close").addEventListener("click", closeModal);
    overlay.addEventListener("click", function (event) {
      if (event.target === overlay) closeModal();
    });
    overlay.addEventListener("cancel", function (event) {
      event.preventDefault();
      closeModal();
    });

    function onMessage(event) {
      if (event.origin.replace(/\/$/, "") !== origin) return;
      var data = event.data || {};
      if (data.type !== "bridgecustom:save-design") return;
      window.removeEventListener("message", onMessage);
      var status = document.createElement("div");
      status.className = "bridgecustom-edit-modal__status";
      status.textContent = "Saving your design…";
      overlay.querySelector(".bridgecustom-edit-modal__dialog").appendChild(status);
      replaceCartLine({
        lineKey: lineKey,
        variantId: variantId,
        quantity: quantity,
        sellingPlan: sellingPlan,
        properties: data.properties || {},
      }).catch(function (err) {
        console.error("Bridge Custom edit design", err);
        window.alert("Could not save the updated design. Please try again.");
        closeModal();
      });
    }
    window.addEventListener("message", onMessage);
  }

  // The iframe is a navigation, so it uses the credentialed connection pool: no crossOrigin here.
  function preconnect(origin) {
    if (document.querySelector('link[rel="preconnect"][href="' + origin + '"]')) return;
    var link = document.createElement("link");
    link.rel = "preconnect";
    link.href = origin;
    document.head.appendChild(link);
  }

  // The closed cart drawer is on every page, so only a button the shopper can actually see
  // (drawer opened, /cart page) builds an editor; one at a time, the rest wait for hover/touch.
  var visibleObserver =
    "IntersectionObserver" in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            visibleObserver.unobserve(entry.target);
            if (Object.keys(preloaded).length === 0) preloadModal(entry.target);
          });
        })
      : null;

  function watchEditButtons() {
    var buttons = document.querySelectorAll("[data-bc-edit]");
    if (!buttons.length) return;
    preconnect(appOriginFrom(buttons[0]));
    if (!visibleObserver) return;
    buttons.forEach(function (button) {
      if (button.__bcWatched) return;
      button.__bcWatched = true;
      visibleObserver.observe(button);
    });
  }

  var watchQueued = false;
  function queueWatch() {
    if (watchQueued) return;
    watchQueued = true;
    window.requestAnimationFrame(function () {
      watchQueued = false;
      watchEditButtons();
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", queueWatch);
  else queueWatch();
  // Cart drawer and cart page re-render their lines after add/change.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        queueWatch();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  ["pointerenter", "pointerdown", "touchstart", "focusin"].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        var target = event.target;
        var button = target && target.closest ? target.closest("[data-bc-edit]") : null;
        if (button) preloadModal(button);
      },
      { capture: true, passive: true },
    );
  });

  document.addEventListener("click", function (event) {
    var button = event.target && event.target.closest ? event.target.closest("[data-bc-edit]") : null;
    if (button) {
      event.preventDefault();
      openModal(button);
      return;
    }
    var media = event.target && event.target.closest ? event.target.closest("[data-bc-zoom]") : null;
    if (!media) return;
    var img = media.querySelector("img");
    var src = media.getAttribute("data-bc-zoom-src") || (img && (img.currentSrc || img.src)) || "";
    if (!src) return;
    event.preventDefault();
    openImageZoom(src, (img && img.getAttribute("alt")) || "");
  });
})();
